
@if (packLimitationService.canDisplayComparisonGraph()) {
  <section>
    <div class="mb-8 flex items-end gap-4">
      <div>
        <span class="mb-1 block text-xs text-greyscale-500">
          {{ "travelBoards.sortBy" | transloco }}
        </span>
        <app-chart-filter (sortedTripsEmitter)="updateFilteredTrips($event)" />
      </div>
      @if (displayGraph && totalCount > displayedCount) {
        <div
          class="mb-2 flex items-center gap-1.5 rounded-full bg-greyscale-100 px-3 py-1"
        >
          <lucide-icon
            name="bar-chart-2"
            [size]="14"
            class="text-greyscale-500"
          ></lucide-icon>
          <span class="text-xs font-medium text-greyscale-600">
            {{ displayedCount }}/{{ totalCount }}
            {{ "travelBoards.tripsShown" | transloco }}
          </span>
        </div>
      }
    </div>
    <div>
      @if (displayGraph) {
        <p-chart
          type="bar"
          [data]="data"
          [options]="options"
          [plugins]="plugins"
          [height]="graphHeight + 'px'"
        />
      }
    </div>
  </section>
} @else {
  <div class="flex items-center justify-center p-4">
    <app-locked-button
      [label]="'travelBoards.comparisonGraph' | transloco"
      [limitedFeature]="graphComparison"
    />
  </div>
}
